import React from 'react';
import close from "../../../assets/Icons/close.png";
import showDemo from "../../../assets/invalidImage/show-demo.png";
import "../signal.css";

const MouthFarAwayError = ({ onClose, onRetake }) => {
    return (
        <div className="h-full bg bg-transparent w-full flex justify-center items-center">
            <div className="bg-white w-11/12 max-w-md flex flex-col items-center p-6 rounded-lg shadow-xl">
                <div className="text-end w-full">
                    <button type="button" onClick={onClose}>
                        <img src={close} className="w-7 h-7" alt="close" />
                    </button>
                </div>
                <div className="text-base py-3 px-4">
                    <p className="font-medium my-1 text-2xl text-center text-signal-ai-blue">
                        ဖုန်းကင်မရာကိုသင့်သွားနဲ့အနီးကပ်ရိုက်ပါ
                    </p>
                </div>
                <div className="my-4">
                    <img src={showDemo} className="h-auto max-w-full" alt="sample" />
                </div>
                <button
                    type="button"
                    className="bg-signal-ai-secondary text-white w-full h-11 font-semibold text-base shadow-2xl rounded-lg"
                    onClick={onRetake}
                >
                    ပြန်ရိုက်မည်
                </button>
            </div>
        </div>
    );
};

export default MouthFarAwayError;
